// CRA 기본 serviceWorkerRegistration.js

// 이 함수는 앱이 오프라인에서도 실행되고, 더 빨리 로드되도록 도와주는 서비스 워커를 등록합니다.
// 기본적으로는 오프라인 기능은 꺼져 있고, 설치 아이콘만 사용하려면 register()만 호출하면 됩니다.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1]은 IPv6 localhost 주소입니다.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8은 IPv4 localhost 범위입니다.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // URL 생성
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // 로컬 환경에서 서비스 워커 체크
        checkValidServiceWorker(swUrl, config);

        navigator.serviceWorker.ready.then(() => {
          console.log(
            '서비스 워커가 로컬 환경에서 실행 중입니다. 더 많은 정보는 https://cra.link/PWA 확인'
          );
        });
      } else {
        // 프로덕션 환경 → 서비스 워커 등록
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // 새 콘텐츠가 사용 가능
              console.log(
                '새 컨텐츠가 준비되었습니다. 페이지를 새로고침하면 적용됩니다.'
              );

              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // 콘텐츠가 캐시됨 → 오프라인 사용 가능
              console.log('콘텐츠가 캐시되었습니다. 앱은 오프라인에서도 동작합니다.');

              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('서비스 워커 등록 실패:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // 서비스 워커 파일 확인
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // 존재하지 않으면 unregister 후 새로고침
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // 유효하면 등록 진행
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        '인터넷 연결이 없습니다. 앱은 오프라인 모드에서 동작합니다.'
      );
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
